<template>
  <div>
    <label v-if="label" class="block text-base font-medium text-gray-700">
      {{ label }} <span v-if="required" class="text-xl text-red-600">*</span>
    </label>
    <textarea
      rows="3"
      :disabled="isDisabled"
      :class="`${
        isDisabled ? 'cursor-not-allowed text-gray-500' : 'text-gray-900'
      } ${className}`"
      class="
        mt-1
        shadow-sm
        focus:ring-cyan-500 focus:border-cyan-500
        block
        w-full
        border border-gray-300
        rounded-md
      "
      :value="value"
      @input="updateValue"
      v-bind="$attrs"
    ></textarea>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,

  props: {
    isDisabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    value: [String, Number],
    className: [String, Object],
  },

  methods: {
    updateValue(event) {
      this.$emit('input', event.target.value)
    },
  },
}
</script>
